import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { FeedbackState } from './types';

export const feedbackSlice = createSlice({
    name: 'feedback',
    initialState,
    reducers: {
        setIsShowCreateFeedbackRequest: (
            state,
            action: PayloadAction<FeedbackState['isShowCreateFeedbackRequest']>
        ) => {
            state.isShowCreateFeedbackRequest = action.payload;
        },
    },
});

export const { setIsShowCreateFeedbackRequest } = feedbackSlice.actions;

export default feedbackSlice.reducer;
